import React, {useEffect, useState} from "react"
import AlertMessage from "../../toolkits/AlertMessage/AlertMessage"
import {Helmet} from "react-helmet"
import SearchForm from "../../toolkits/SearchForm/SearchForm"
import {useDispatch, useSelector} from "react-redux"
import {PAGE_SIZE, PURCHASE_REQUEST_STATUS} from "../../constants/other"
import {receiveNextPagePurchaseRequests, receivePurchaseRequests} from "./actions/purchaseRequestsActions"
import PurchaseRequestsTable from "./components/PurchaseRequestsTable"
import InfiniteScroll from "react-infinite-scroller"
import CircularProgress from "../../toolkits/CircularProgress/CircularProgress"
import StyledCircularProgress from "../../toolkits/CircularProgress/CircularProgress"
import "./index.scss"
import FilterPanel from "../../toolkits/FilterPanel"

const PurchaseRequests = () => {
    const dispatch = useDispatch()
    const [userMessage, setUserMessage] = useState(null)
    const [searchKey, setSearchKey] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [statusFilter, setStatusFilter] = useState(PURCHASE_REQUEST_STATUS.ALL)

    const {
        loading,
        tableLoading,
        purchaseRequests,
        total,
    } = useSelector((state) => state.purchaseRequests)

    const getPurchaseRequests = (page) => {
        page = page ? page : currentPage
        const params = {
            size: PAGE_SIZE,
            page,
            username: searchKey,
            status: statusFilter === PURCHASE_REQUEST_STATUS.ALL ? null : statusFilter
        }

        dispatch(receivePurchaseRequests(params))
        setCurrentPage(page + 1)
    }

    const getNextPurchaseRequests = () => {
        const params = {
            page: currentPage,
            size: PAGE_SIZE,
            username: searchKey,
            status: statusFilter === PURCHASE_REQUEST_STATUS.ALL ? null : statusFilter
        }

        dispatch(receiveNextPagePurchaseRequests(params))
        setCurrentPage(currentPage + 1)
    }

    useEffect(() => {
        getPurchaseRequests(1)
    }, [statusFilter, searchKey])

    return (
        <>
            <Helmet>
                <title>Purchase Requests - Newsoft Inside</title>
            </Helmet>
            <div className="purchase-requests">
                <div>
                    {userMessage &&
                        <AlertMessage setMessage={setUserMessage} message={userMessage.message} code={userMessage.code}/>
                    }
                </div>
                <div className="purchase-requests-header">
                    <div className="purchase-requests-header-search">
                        <SearchForm onChange={setSearchKey} debounceMs={500} />
                        <FilterPanel
                            title={"Type"}
                            options={PURCHASE_REQUEST_STATUS}
                            selectedOption={statusFilter}
                            setOptionFilter={setStatusFilter}
                        />
                    </div>
                </div>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={getNextPurchaseRequests}
                    hasMore={!tableLoading && purchaseRequests.length < total}
                    loader={<CircularProgress key="circular-progress"/>}
                    datalength={purchaseRequests.length}
                >
                    {loading ? <StyledCircularProgress/> :
                        <div className="purchase-requests-content">
                            <PurchaseRequestsTable
                                purchaseRequests={purchaseRequests}
                                setUserMessage={setUserMessage}
                                refreshTable={() => getPurchaseRequests(1)}
                            />
                        </div>
                    }
                </InfiniteScroll>
            </div>
        </>
    )
}

export default PurchaseRequests